import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db, storage } from "../../../firebase";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  LinearProgress,
  Box,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";

import { getClientes } from "../../../services/modules/Clientes";
import { getPapeleria } from "../../../services/modules/Papeleria";

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#000", // Fondo negro
      color: "#fff", // Texto blanco
      fontWeight: "bold", // Negrita en los encabezados
      textAlign: "center", // Alinear texto al centro
    },
  },
  rows: {
    style: {
      textAlign: "center", // Centrar contenido en las filas
    },
  },
};

const Papeleria = () => {
  const [clientes, setClientes] = useState([]);
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [searchDPI, setSearchDPI] = useState("");
  const [loading, setLoading] = useState(true);
  const [openPapeleriaModal, setOpenPapeleriaModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [papeleria, setPapeleria] = useState([]);
  const [editData, setEditData] = useState({
    id: null,
    FechaVencimiento: "",
    DocumentoAdjunto: null,
  });

  useEffect(() => {
    fetchClientes();
  }, []);

  const fetchClientes = async () => {
    try {
      const data = await getClientes();
      setClientes(data || []);
      console.log(data);
      setFilteredClientes(data || []);
    } catch (err) {
      console.error("Error al cargar los clientes:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPapeleria = async (codigoCliente) => {
    try {
      console.log("Fetching papelería using getPapeleria service:", codigoCliente);
      const papeleriaData = await getPapeleria(codigoCliente);
      console.log(codigoCliente);
      console.log("Papelería data fetched:", papeleriaData);
      setPapeleria(papeleriaData);
    } catch (err) {
      console.error("Error fetching papelería:", err);
    }
  };

  const handleSearchDPI = () => {
    if (searchDPI.trim() === "") {
      setFilteredClientes(clientes);
    } else {
      const filtered = clientes.filter((cliente) => cliente.dpi === searchDPI.trim());
      setFilteredClientes(filtered);
    }
  };

  const handleOpenPapeleriaModal = (cliente) => {
    setSelectedCliente(cliente);
    fetchPapeleria(cliente.id);
    setOpenPapeleriaModal(true);
  };

  const handleClosePapeleriaModal = () => {
    setOpenPapeleriaModal(false);
    setPapeleria([]);
  };

  const handleOpenEditModal = (row) => {
    setEditData({
      id: row.id,
      FechaVencimiento: row.FechaVencimiento || "",
      DocumentoAdjunto: null,
    });
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setEditData({ id: null, FechaVencimiento: "", DocumentoAdjunto: null });
  };

  const handleEditFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditData((prev) => ({ ...prev, DocumentoAdjunto: file }));
    }
  };

 const handleSaveEdit = async () => {
  const { id, FechaVencimiento, DocumentoAdjunto } = editData;

  try {
    let fileURL = null;

    if (DocumentoAdjunto) {
      const fileRef = ref(storage, `papeleria/${selectedCliente.id}/${DocumentoAdjunto.name}`);
      
      // 🔑 Subir archivo con metadata de descarga directa
      await uploadBytes(fileRef, DocumentoAdjunto, {
        contentType: DocumentoAdjunto.type,
        contentDisposition: `attachment; filename="${DocumentoAdjunto.name}"`,
      });

      fileURL = await getDownloadURL(fileRef);
    }

    const docRef = doc(db, "papeleria", id);
    await updateDoc(docRef, {
      FechaVencimiento: FechaVencimiento || null,
      ...(fileURL && { DocumentoURL: fileURL }),
    });

    alert("Documento actualizado correctamente.");
    fetchPapeleria(selectedCliente.id);
    handleCloseEditModal();
  } catch (err) {
    console.error("Error al actualizar el documento:", err);
    alert("Hubo un problema al actualizar el documento.");
  }
};

const handleDownload = (url, filename) => {
  if (!url) {
    alert("No existe ningún documento subido.");
    return;
  }

  const clienteNombre =
    (selectedCliente?.nombres || "Cliente").replace(/\s+/g, "_");
  const fullFilename = `${clienteNombre}_${filename || "documento.pdf"}`;

  // agrega el parámetro para forzar descarga
  const sep = url.includes("?") ? "&" : "?";
  const forcedUrl =
    url +
    `${sep}response-content-disposition=` +
    encodeURIComponent(`attachment; filename="${fullFilename}"`);

  // redirigir a la URL forzada → el navegador descargará
  window.location.href = forcedUrl;
};


  const calcularProgresoEstado = (row) => {
    if (!row.DocumentoURL) return { porcentaje: 100, color: "red" };
    if (!row.FechaVencimiento) return { porcentaje: 100, color: "green" };

    const hoy = new Date();
    const vencimiento = new Date(row.FechaVencimiento);
    const diferenciaDias = (vencimiento - hoy) / (1000 * 60 * 60 * 24);

    if (diferenciaDias < 0) return { porcentaje: 100, color: "red" };
    return { porcentaje: 100, color: "green" };
  };

  const papeleriaColumns = [
    {
      name: "Nombre Documento",
      selector: (row) => row.NombreDocumento || "Sin Nombre",
      sortable: true,
    },
    {
      name: "Condición",
      selector: (row) => (row.DocumentoURL ? "Cargado" : "No cargado"),
      sortable: true,
    },
    {
      name: "Fecha Vigencia",
      selector: (row) => {
        if (row.FechaVencimiento) {
          const date = new Date(row.FechaVencimiento);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return "";
      },
      sortable: true,
    },
    {
      name: "Estado",
      cell: (row) => {
        const { porcentaje, color } = calcularProgresoEstado(row);
        return (
          <Box display="flex" alignItems="center" gap="10px">
            <LinearProgress
              variant="determinate"
              value={porcentaje}
              sx={{
                width: "100px",
                height: "8px",
                backgroundColor: "lightgray",
                "& .MuiLinearProgress-bar": { backgroundColor: color },
              }}
            />
            <span style={{ color }}>{porcentaje}%</span>
          </Box>
        );
      },
    },
    {
      name: "Acciones",
      cell: (row) => (
        <Box display="flex" gap="10px">
          <IconButton
            color="primary"
            onClick={() => handleDownload(row.DocumentoURL, row.NombreDocumento)}
          >
            <DownloadIcon />
          </IconButton>
          <IconButton color="secondary" onClick={() => handleOpenEditModal(row)}>
            <EditIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  if (loading) return <p>Cargando...</p>;

  return (
    <div>
      <h1>Clientes</h1>
      <TextField
        label="Buscar por DPI"
        variant="outlined"
        value={searchDPI}
        onChange={(e) => setSearchDPI(e.target.value)}
        sx={{ mb: 2, width: "300px" }}
      />
      <Button variant="contained" color="primary" onClick={handleSearchDPI} sx={{ mb: 2 }}>
        Buscar
      </Button>
      <DataTable
        title="Lista de Clientes"
        columns={[
          { name: "Nombre", selector: (row) => row.nombres, sortable: true },
          { name: "DPI", selector: (row) => row.dpi, sortable: true },
          {
            name: "Acciones",
            cell: (row) => (
              <IconButton onClick={() => handleOpenPapeleriaModal(row)}>
                <VisibilityIcon />
              </IconButton>
            ),
          },
        ]}
        data={filteredClientes}
        pagination
        customStyles={customStyles}
      />

      <Dialog open={openPapeleriaModal} onClose={handleClosePapeleriaModal} maxWidth="lg" fullWidth>
        <DialogTitle>Papelería de {selectedCliente?.nombres}</DialogTitle>
        <DialogContent>
          <DataTable
            title="Papelería"
            columns={papeleriaColumns}
            data={papeleria}
            customStyles={customStyles}
            pagination
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePapeleriaModal} color="secondary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditModal} onClose={handleCloseEditModal} maxWidth="sm" fullWidth>
        <DialogTitle>Editar Documento</DialogTitle>
        <DialogContent>
          <TextField
            label="Fecha de Vencimiento"
            type="date"
            fullWidth
            margin="normal"
            value={editData.FechaVencimiento}
            onChange={(e) => setEditData({ ...editData, FechaVencimiento: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <div>
            <input
              type="file"
              id="file-edit-upload"
              style={{ display: "none" }}
              onChange={handleEditFileChange}
            />
            <label htmlFor="file-edit-upload">
              <Button variant="contained" component="span">
                Seleccionar Archivo
              </Button>
            </label>
            {editData.DocumentoAdjunto && (
              <p>Archivo seleccionado: {editData.DocumentoAdjunto.name}</p>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditModal} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Guardar Cambios
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Papeleria;
